import type { Translation } from "./types";

const es: Translation = {
  home: {
    title: "AI my bro",
    subtitle: "Es hora de construir!",
  },
  about: {
    link: "Sobre nosotros",
    title: "Sobre nosotros",
    subtitle: "El equipo y nuestro compromiso detrás de AI my bro",
  },
  navigation: {
    en: "Inglés",
    kr: "Coreano",
    es: "Español",
    zh: "Chino",
  },
  menu: {
    explain: "Explicar",
    chat: "Chat",
    quiz: "Quiz",
    progress: "Progreso",
  },
  auth: {
    login: {
      title: "Iniciar sesión en tu cuenta",
      subtitle: "Por favor ingresa tus datos",
      email: "Correo electrónico",
      password: "Contraseña",
      forgotPassword: "¿Olvidaste tu contraseña?",
      loginButton: "Iniciar sesión",
      emailNotConfirmed: "Correo electrónico no confirmado",
      resendConfirmation: "Reenviar correo de confirmación",
      noAccount: "¿No tienes una cuenta?",
      signUp: "Registrarse",
      emailPlaceholder: "ejemplo@email.com",
      passwordPlaceholder: "Ingresa tu contraseña",
    },
    join: {
      title: "Crear una cuenta",
      subtitle: "Por favor ingresa tus datos para crear una cuenta",
      name: "Nombre",
      email: "Correo electrónico",
      password: "Contraseña",
      confirmPassword: "Confirmar contraseña",
      marketingConsent: "Suscribirse a correos de marketing",
      termsAgreement:
        "He leído y acepto los Términos de Servicio y Política de Privacidad",
      termsOfService: "Términos de Servicio",
      privacyPolicy: "Política de Privacidad",
      createAccount: "Crear cuenta",
      accountCreated: "¡Cuenta creada!",
      emailVerificationRequired:
        "Verificación de correo electrónico requerida. Por favor revisa tu correo.",
      alreadyHaveAccount: "¿Ya tienes una cuenta?",
      signIn: "Iniciar sesión",
      namePlaceholder: "Juan Pérez",
      emailPlaceholder: "ejemplo@email.com",
      passwordHint: "Debe tener al menos 8 caracteres.",
      passwordPlaceholder: "Ingresa tu contraseña",
      confirmPasswordPlaceholder: "Ingresa tu contraseña nuevamente",
      and: "y",
      agreeTo: ".",
    },
    forgotPassword: {
      title: "¿Olvidaste tu contraseña?",
      subtitle:
        "Ingresa tu correo electrónico y te enviaremos un enlace de restablecimiento.",
      email: "Correo electrónico",
      emailPlaceholder: "ejemplo@email.com",
      sendButton: "Enviar enlace de restablecimiento",
      successMessage:
        "Revisa tu correo electrónico para obtener un enlace de restablecimiento, puedes cerrar esta pestaña.",
    },
    newPassword: {
      title: "Actualiza tu contraseña",
      subtitle: "Ingresa tu nueva contraseña y confírmala.",
      password: "Contraseña",
      confirmPassword: "Confirmar contraseña",
      passwordPlaceholder: "Ingresa tu nueva contraseña",
      confirmPasswordPlaceholder: "Confirma tu nueva contraseña",
      updateButton: "Actualizar contraseña",
      successMessage: "¡Contraseña actualizada exitosamente!",
      passwordsMatchError: "Las contraseñas deben coincidir",
      redirectMessage:
        "Redirigiendo a la página de inicio de sesión en {{seconds}} segundos...",
      goToLogin: "Ir a Iniciar Sesión",
    },
  },
  landing: {
    hero: {
      quote:
        "Estudia lo que más te interese de la manera más indisciplinada, irreverente y original posible",
      author: "Richard Feynman",
    },
    intro: {
      title: "Aprendizaje Autodirigido con AI my bro",
      subtitle:
        "Cuanto más explicas, más inteligente te vuelves. AI bro te da comentarios lindos y perspicaces.",
      features: {
        organize: "Organizar Ideas",
        practice: "Practicar Explicando",
        learning: "Aprendizaje Profundo",
      },
      cta: "Empezar a Enseñar a AI Bro",
    },
    examples: {
      title: "¡Así es Como la Gente Explicó las Cosas!",
      physics: {
        user: "La gravedad es la fuerza que hace que las cosas caigan",
        ai: "¡Correcto! La manzana también cayó al suelo 🍎 ¿Pero por qué no cae la luna?",
      },
      biology: {
        user: "La fotosíntesis es cómo las plantas hacen comida usando luz",
        ai: "¡Guau! 🌱 ¡Entonces las plantas son como chefs! ¿Qué ingredientes necesitan?",
      },
      politics: {
        user: "La democracia es cuando el pueblo gobierna el país",
        ai: "¡Genial! 🗳️ ¿Entonces cualquiera puede ser presidente?",
      },
    },
    footer: {
      description:
        "AI my bro es tu compañero de aprendizaje confiable que te ayuda a desarrollar el poder de organizar el conocimiento a través de las palabras.",
    },
  },
  contact: {
    title: "Contáctanos",
    subtitle:
      "¿Tienes alguna pregunta? No dudes en contactarnos. Te responderemos rápidamente.",
    form: {
      name: "Nombre",
      email: "Correo electrónico",
      message: "Mensaje",
      namePlaceholder: "Ingresa tu nombre",
      emailPlaceholder: "Ingresa tu correo electrónico",
      messagePlaceholder: "Ingresa tu mensaje",
      sendButton: "Enviar",
      captchaNote:
        "Usando Cloudflare Turnstile para mayor seguridad y experiencia de usuario.",
    },
    messages: {
      success: "Mensaje enviado exitosamente",
      error: "Ocurrió un error al enviar tu mensaje",
      captchaError:
        "La verificación de seguridad falló. Por favor intenta de nuevo.",
    },
  },
  legal: {
    privacyPolicy: "Política de Privacidad",
    termsOfService: "Términos de Servicio",
    youthPolicy: "Política de Protección Juvenil",
    cookiePolicy: "Política de Cookies",
  },
  settings: {
    profile: {
      title: "Función de edición de perfil (temporalmente deshabilitada)",
      subtitle: "Puedes ver la información de tu perfil.",
      name: "Nombre",
    },
    name: {
      title: "Cambiar nombre",
      subtitle: "Cambia tu nombre de visualización.",
      currentName: "Nombre actual",
      newName: "Nuevo nombre",
      namePlaceholder: "Ingresa nuevo nombre",
      changeButton: "Cambiar nombre",
      successMessage: "Nombre cambiado exitosamente",
    },
    email: {
      title: "Cambiar correo electrónico",
      titleAdd: "Agregar correo electrónico",
      subtitle: "Cambia tu dirección de correo electrónico.",
      subtitleAdd: "Agrega una dirección de correo electrónico a tu cuenta.",
      currentEmail: "Correo electrónico actual",
      newEmail: "Nuevo correo electrónico",
      changeButton: "Cambiar correo electrónico",
      addButton: "Agregar correo electrónico",
      successMessage:
        "El proceso de actualización de correo electrónico ha comenzado. Por favor revisa tu correo anterior para un enlace de verificación.",
    },
    password: {
      title: "Cambiar contraseña",
      titleAdd: "Agregar contraseña",
      subtitle: "Cambia tu contraseña.",
      subtitleAdd: "Agrega una contraseña a tu cuenta.",
      newPassword: "Nueva contraseña",
      confirmPassword: "Confirmar nueva contraseña",
      changeButton: "Cambiar contraseña",
      addButton: "Agregar contraseña",
      successMessage: "Contraseña actualizada",
    },
    social: {
      title: "Conectar cuentas sociales",
      subtitle:
        "Agrega o elimina métodos de autenticación adicionales a tu cuenta.",
    },
    danger: {
      title: "Zona de Peligro",
      confirmDelete: "Confirmo que quiero eliminar mi cuenta.",
      confirmIrreversible: "Entiendo que esta acción es irreversible.",
      deleteButton: "Eliminar cuenta",
    },
  },
  error: {
    title: "Error",
    errorCode: "Código de error",
    goHome: "Ir al inicio",
    otpExpired: "El enlace del correo electrónico no es válido o ha caducado",
    invalidLink:
      "El enlace del correo electrónico ha caducado o ya se ha utilizado. Por favor, solicita un restablecimiento de contraseña nuevamente.",
  },
  common: {
    beta: "BETA",
    betaNotice:
      "Este servicio está en beta. Por favor, envíanos tus comentarios si encuentras algún problema.",
  },
};

export default es;
